import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import colControl from '@/components/colControl/colControl';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { CheckColMixin } from '@/mixins/CheckColMixin';
import { downloadFile } from '@/api/manage';
import { httpAction } from '@/api/manage';
import popOut from "./com/popOut.vue";
import moment from 'moment';
export default {
  name: 'waterData',
  components: {
    popOut: popOut,
    colControl: colControl
  },
  data: function data() {
    return {
      fatorDetail: {},
      buttonState: false,
      isorter: {
        column: 'status',
        order: 'asc'
      },
      showPop: false,
      colShow: false,
      moment: moment // cols: [
      //   {
      //     title: '操作',
      //     dataIndex: 'action',
      //     align: 'center',
      //     width: 150,
      //     scopedSlots: { customRender: 'action' }
      //   },
      //   {
      //     title: '监测时间',
      //     align: 'center',
      //     width: 150,
      //     dataIndex: 'dataTime',
      //     colName: 'data_time'
      //   },
      //   {
      //     title: '审核状态',
      //     align: 'center',
      //     width: 150,
      //     dataIndex: 'statusName',
      //     colName: 'status'
      //   },
      //   {
      //     title: '审核时间',
      //     align: 'center',
      //     width: 150,
      //     dataIndex: 'checkTime',
      //     colName: 'check_time'
      //   }
      // ]

    };
  },
  mixins: [GetSiteIdMixin, CheckColMixin],
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];
      this.delayLoadData();

      if (window.sessionStorage.getItem('siteType')) {
        this.getCol(window.sessionStorage.getItem('siteType'));
      }
    }
  },
  created: function created() {
    var _this = this;

    // this.url = '/online/st21/cn2061'
    this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/cn2061';
    this.exportUrl = "online/st".concat(window.sessionStorage.getItem('siteType'), "/export");
    this.queryParam.onlineData = 1;
    window.addEventListener('setItem', function (e) {
      if (e.key == 'siteType') {
        // this.url = '/online/st21/cn2061'
        _this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/cn2061';
        _this.exportUrl = "online/st".concat(window.sessionStorage.getItem('siteType'), "/export");
      }
    });
    this.queryParam.stime = moment().subtract(1, 'weeks').format('YYYY-MM-DD HH:mm:ss');
    this.queryParam.etime = moment(moment().format('YYYY-MM-DD') + ' 23:59:59').format('YYYY-MM-DD HH:mm:ss');
  },
  mounted: function mounted() {// this.$bus.$emit('st','21')
  },
  methods: {
    close: function close(value) {
      this.showPop = value;
    },
    handleAudit: function handleAudit(value, index) {
      console.log('value', value);
      this.showPop = true;
      this.fatorDetail = value;
      this.buttonState = value.attrs.status != '0' ? true : false;
      this.factorSource.forEach(function (item, index) {
        if (value.factor[item.code]) {
          item.value = value.factor[item.code].value;
          item.remark = "";
          var check = value.factor[item.code].check;
          if (null != check) item.remark = check.message;
        }
      });
    },
    onDateChange: function onDateChange(value, dateString) {
      this.queryParam.stime = dateString[0];
      this.queryParam.etime = dateString[1];
      this.loadData();
    },
    onDateOk: function onDateOk(value) {},
    handleCheck: function handleCheck(record, s) {
      var _this2 = this;

      var that = this;
      var param = {
        id: record.attrs.msgId,
        status: s
      };
      httpAction('/cmd/msg', param, 'put').then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: '操作成功!'
          });
        } else {
          that.$notification.success({
            message: '操作失败!'
          });
        }
      }).finally(function () {
        _this2.loadData();
      });
    },
    handleExportXls: function handleExportXls(s) {
      var url = '/st21/cn2061/exportXls';
      downloadFile(s, url, this.queryParam);
    }
  }
};